/* eslint-disable @typescript-eslint/no-explicit-any */
'use client';

import { cn, type Control, Controller, motion, tv } from '@/libs';

type SwitchProps = {
  control: Control<any>;
  name: string;
  size?: 'small' | 'medium' | 'large';
  label?: string;
  className?: string;
} & React.HTMLAttributes<HTMLLabelElement>;

const switchVariants = tv({
  base: 'flex cursor-pointer rounded-full transition-colors text-foreground bg-foreground/10 peer-checked:bg-secondary-text',
  variants: {
    size: {
      large: 'p-0.5 h-8 w-16',
      medium: 'p-0.5 h-6 w-12',
      small: 'p-0.5 h-4 w-8',
    },
  },
});

export const Switch = ({
  control,
  name,
  size = 'medium',
  className,
  label,
  ...props
}: SwitchProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <label className="flex items-center text-sm gap-2" {...props}>
          <input
            type="checkbox"
            className="peer sr-only"
            checked={value}
            onChange={onChange}
          />
          <div
            className={cn(
              switchVariants({ size }),
              value ? 'justify-end' : 'justify-start',
              className,
            )}
          >
            <motion.div
              className="h-full aspect-square rounded-full bg-current transition-colors shadow-md shadow-black/30"
              layout
              transition={{ type: 'spring', visualDuration: 0.2, bounce: 0.4 }}
            />
          </div>
          {label && <span>{label}</span>}
        </label>
      )}
    />
  );
};
